import { useSelector, useDispatch } from 'react-redux';
import { selectSportsbookBetBuilderEnabled } from '../../../../brand/ducks/selectors';
import { EventDto, EventTags } from '../../api/sbapi/sbapi-api-model';
import { useCallback } from 'react';
import { AppDispatch } from '../../../../../store/types';
import { openBetBuilder } from './sportsbook-bet-builder-modal-duck';
import useOddsFormat from '../../hooks/use-odds-format';

const useBetBuilderModal = (event: EventDto | null) => {
	const dispatch: AppDispatch = useDispatch();
	const isBetBuilderEnabled = useSelector(selectSportsbookBetBuilderEnabled);
	const hasBetBuilderForEvent =
		isBetBuilderEnabled &&
		!!event?.tags?.includes(EventTags.HAS_BET_BUILDER) &&
		!!event?.metadata?.betBuilderId &&
		!event.isLive;
	const betBuilderId = event?.metadata?.betBuilderId;
	const { oddsFormat } = useOddsFormat();
	const hasReversedOrder = event?.tags.includes(EventTags.HAS_REVERSED_ORDER) || false;

	const openBetBuilderForEvent = useCallback(() => {
		if (betBuilderId) {
			dispatch(openBetBuilder(betBuilderId, oddsFormat, hasReversedOrder));
		}
	}, [dispatch, betBuilderId, oddsFormat, hasReversedOrder]);

	return {
		hasBetBuilderForEvent,
		openBetBuilderForEvent
	};
};

export default useBetBuilderModal;
